import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createLinePayPayment(
    bills,
    method,
    receive,
    depositUsed,
    receiveDate,
    status,
    billingID,
    amount,
    optUserID
  ) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/linepay?optUserID=${optUserID}`;
    return httpPost(apiUrl, {
      bills,
      method,
      receive,
      depositUsed,
      receiveDate,
      status,
      billingID,
      amount,
    });
  }

  confirmLinePay(orderId, amount, transactionId) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/linePay/confirm?transactionId=${transactionId}&orderId=${orderId}&amount=${amount}`;
    return httpPost(apiUrl);
  }

  checkLinePayPayment(orderId, transactionId) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/linePay/check?orderId=${orderId}&transactionId=${transactionId}`;
    return httpGet(apiUrl);
  }

  cancelLinePayPayment(orderId, transactionId) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/linePay/cancel?orderId=${orderId}&transactionId=${transactionId}`;
    return httpPost(apiUrl);
  }
}
